<template>
  <div id="sidebar">
    <div
      v-b-visible="handleVisible"
      class="position-fixed d-block d-lg-none"
    ></div>
    <div id="logo">
      <b-tooltip target="burger-menu" placement="bottom" triggers="hover">
        <span v-if="drawerStatus">Cliquez pour agrandir le menu</span>
        <span v-else>Cliquez pour réduire le menu</span>
      </b-tooltip>

      <font-awesome-icon
        id="burger-menu"
        icon="bars"
        class="menu-burger"
        @click="setDrawer(!drawerStatus)"
      ></font-awesome-icon>

      <img
        src="../img/baniere_adn83.png"
        class="big-logo"
        alt="Sud THD"
      />
      <b-img src="../img/logo_adn83.png" class="small-logo" alt="Sud THD" />
    </div>
    <div class="avatar">
      <div class="container-avatar">
        <b-img
          v-if="userConnected && userConnected.picture == null"
          img
          src="../img/avatar-client.png"
          alt="user-img"
        />
        <b-img-lazy
          v-else
          img
          :src="userConnected.picture"
          alt="user-img"
          class="img-circle"
        />
      </div>
      <div class="user-info">
        <h5 class="user-name">
          {{ userConnected.lastName }} {{ userConnected.firstName }}
        </h5>
        <span class="user-mail">{{ userConnected.email }}</span>
      </div>
    </div>
    <b-tooltip
      target="tooltip-goToDossier"
      v-if="drawerStatus == true"
      placement="right"
    >
      Liste des demandes
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToRetards"
      v-if="
        drawerStatus == true &&
        (userConnected.roles.includes('ROLE_GUICHET') ||
          userConnected.roles.includes('ROLE_GESTIONNAIRE'))
      "
      placement="right"
    >
      Demandes en retard
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToUsers"
      v-if="drawerStatus == true"
      placement="right"
    >
      Gestion des utilisateurs
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToAccount"
      v-if="drawerStatus == true"
      placement="right"
    >
      Mon compte
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToGestOperator"
      v-if="drawerStatus == true"
      placement="right"
    >
      Gestion des opérateurs
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToGestSoustraitant"
      v-if="drawerStatus == true"
      placement="right"
    >
      Gestion des sous traitants
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToCatalogue"
      v-if="drawerStatus == true"
      placement="right"
    >
      Catalogue
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToDocuments"
      v-if="drawerStatus == true"
      placement="right"
    >
      Documents
    </b-tooltip>
    <!-- <b-tooltip
      target="tooltip-goToSuivi"
      v-if="drawerStatus == true"
      placement="right"
    >
      Application Suivi VAR THD
    </b-tooltip> -->
    <b-tooltip
      target="tooltip-goToStatistics"
      v-if="drawerStatus == true"
      placement="right"
    >
      Statistiques
    </b-tooltip>
    <b-tooltip
      target="tooltip-goToIneris"
      v-if="drawerStatus == true"
      placement="right"
    >
      Déclaration INERIS
    </b-tooltip>
    <!-- <b-tooltip
      target="tooltip-goToHistorique"
      v-if="drawerStatus == true"
      placement="right"
    >
      Historique
    </b-tooltip> -->
    <b-tooltip
      target="tooltip-goToDisconnect"
      v-if="drawerStatus == true"
      placement="right"
    >
      Se déconnecter
    </b-tooltip>
    <!-- <b-tooltip
      target="tooltip-goToOldGuichet"
      v-if="drawerStatus == true"
      placement="right"
    >
      Ancien guichet
    </b-tooltip> -->
    <!-- <b-tooltip
      target="tooltip-goToBroadcastMessage"
      v-if="drawerStatus == true"
      placement="right"
    >
      Message général
    </b-tooltip> -->
    <div id="menu">
      <ul>
        <li id="tooltip-goToDossier">
          <router-link to="/dossiers">
            <font-awesome-icon icon="folder"></font-awesome-icon>
            Liste des demandes
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li
          id="tooltip-goToRetards"
          v-if="
            userConnected.roles.includes('ROLE_GUICHET') ||
            userConnected.roles.includes('ROLE_GESTIONNAIRE')
          "
        >
          <router-link to="/retards">
            <font-awesome-icon icon="clock"></font-awesome-icon>
            Demandes en retard
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li id="tooltip-goToUsers">
          <router-link to="/users">
            <font-awesome-icon icon="users"></font-awesome-icon>
            Gestion des utilisateurs
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li id="tooltip-goToAccount">
          <router-link to="/account">
            <font-awesome-icon icon="user"></font-awesome-icon>
            Mon compte
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li
          v-if="userConnected.roles.includes('ROLE_ADMIN')"
          id="tooltip-goToGestOperator"
        >
          <router-link to="/groups/operator">
            <font-awesome-icon icon="user-tie"></font-awesome-icon>
            Gestion des opérateurs
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li
          v-if="userConnected.roles.includes('ROLE_ADMIN')"
          id="tooltip-goToGestSoustraitant"
        >
          <router-link to="/groups/soustraitant">
            <font-awesome-icon icon="hard-hat"></font-awesome-icon>
            Gestion des sous traitants
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <!-- <li id="tooltip-goToCatalogue" @click="goToCatalogue()">
          <font-awesome-icon icon="book"></font-awesome-icon>
          Catalogue
          <font-awesome-icon
            class="menu-arrow"
            icon="angle-right"
          ></font-awesome-icon>
        </li> -->
        <li v-if="userConnected" id="tooltip-goToDocuments">
          <router-link to="/documents">
            <font-awesome-icon icon="file"></font-awesome-icon>
            Documents
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <!-- <li @click="goToSuivi()" v-if="userConnected" id="tooltip-goToSuivi">
          <font-awesome-icon icon="chart-bar"></font-awesome-icon>
          Application Suivi VAR THD
          <font-awesome-icon
            class="menu-arrow"
            icon="angle-right"
          ></font-awesome-icon>
        </li> -->
        <li v-if="userConnected" id="tooltip-goToStatistics">
          <router-link to="/statistics">
            <font-awesome-icon icon="chart-bar"></font-awesome-icon>
            Statistiques
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <li v-if="userConnected" id="tooltip-goToIneris">
          <router-link to="/ineris">
            <font-awesome-icon icon="file-export"></font-awesome-icon>
            Déclaration INERIS
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>

        <!-- <li
          v-if="userConnected"
          id="tooltip-goToOldGuichet"
          @click="openGuichet"
        >
          <font-awesome-icon icon="archive"></font-awesome-icon>
          Ancien guichet
          <font-awesome-icon
            class="menu-arrow"
            icon="angle-right"
          ></font-awesome-icon>
        </li>
        <li @click="toDocsFaq()" id="tooltip-goToDocsFaq">
          <font-awesome-icon icon="question"></font-awesome-icon>
          Docs et FAQ
          <font-awesome-icon
            class="menu-arrow"
            icon="angle-right"
          ></font-awesome-icon>
        </li> -->
        <li
          v-if="userConnected.roles.includes('ROLE_IFT')"
          id="tooltip-goToHistorique"
        >
          <router-link to="/history">
            <font-awesome-icon icon="user-secret"></font-awesome-icon>
            Historique
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li>
        <!-- <li
          v-if="userConnected.roles.includes('ROLE_ADMIN')"
          id="tooltip-goToBroadcastMessage"
        >
          <router-link to="/message">
            <font-awesome-icon icon="comment"></font-awesome-icon>
            Message général
            <font-awesome-icon
              class="menu-arrow"
              icon="angle-right"
            ></font-awesome-icon>
          </router-link>
        </li> -->
        <li @click="logout" id="tooltip-goToDisconnect">
          <font-awesome-icon icon="door-closed"></font-awesome-icon>
          Se déconnecter
          <font-awesome-icon
            class="menu-arrow"
            icon="angle-right"
          ></font-awesome-icon>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";

export default {
  name: "Sidebar",
  watch: {
    isXsSmMd: {
      handler: function (val) {
        this.setDrawer(val);
      },
    },
  },
  data() {
    return {
      isXsSmMd: false,
    };
  },

  methods: {
    toDocsFaq() {
      window.open("https://www.sud-thd.net/le-syndicat-sud-thd/acces-membres/");
    },
    goToSuivi() {
      window.open(
        "https://sig.paca-thd.net/portal/apps/opsdashboard/index.html#/1e13e0e7f20b43ad928d89a7a236fd22"
      );
    },
    goToCatalogue() {
      window.open(
        "https://trouver.crige-paca.org/dataset?q=smo+sud+thd&sort=metadata_modified+desc&ext_bbox=&ext_prev_extent=3.2080078125%2C42.32606244456202%2C9.16259765625%2C45.49094569262732"
      );
    },
    openGuichet() {
      window.open("https://guichetv2.sud-thd.net");
    },
    handleVisible(isVisible) {
      this.isXsSmMd = isVisible;
    },
    ...Vuex.mapActions("Authentification", ["logout", "setDrawer"]),
  },
  computed: {
    ...Vuex.mapGetters("Authentification", ["userConnected", "drawerStatus"]),
  },
};
</script>

<style scoped></style>
